export const DEFAULT_MENU_TAG_I18N = Object.freeze({
  tags: Object.freeze({
    beef: 'Beef',
    pork: 'Pork',
    chicken: 'Chicken',
    duck: 'Duck',
    poultry: 'Poultry',
    fish: 'Fish',
    shrimp: 'Shrimp',
    squid: 'Squid',
    crab: 'Crab',
    seafood: 'Seafood',
    vegetarian: 'Vegetarian',
    vegan: 'Vegan',
    bestseller: 'Best Seller',
    nuts: 'Nuts',
    dairy: 'Dairy',
    eggs: 'Eggs',
    gluten: 'Contains Gluten',
    gluten_free: 'Gluten Free',
  }),
  negativeFilters: Object.freeze({
    beef: 'No Beef',
    pork: 'No Pork',
    chicken: 'No Chicken',
    duck: 'No Duck',
    poultry: 'No Poultry',
    fish: 'No Fish',
    shrimp: 'No Shrimp',
    squid: 'No Squid',
    crab: 'No Crab',
    seafood: 'No Seafood',
    vegetarian: 'No Vegetarian',
    vegan: 'No Vegan',
    bestseller: 'Not Best Seller',
    nuts: 'No Nuts',
    dairy: 'No Dairy',
    eggs: 'No Eggs',
    gluten: 'No Gluten',
    gluten_free: 'Not Gluten Free',
  }),
  spiciness: Object.freeze({
    mild: 'Mild',
    medium: 'Medium Spice',
    hot: 'Hot',
  }),
  ui: Object.freeze({
    clearFilters: 'Clear Filters',
    noItemsMatch: 'No items match your current filters right now.',
  }),
});

const MENU_TAG_I18N_BY_LANGUAGE = Object.freeze({
  en: DEFAULT_MENU_TAG_I18N,
  vi: {
    tags: {
      beef: 'Bò',
      pork: 'Heo',
      chicken: 'Gà',
      duck: 'Vịt',
      poultry: 'Gia cầm',
      fish: 'Cá',
      shrimp: 'Tôm',
      squid: 'Mực',
      crab: 'Cua',
      seafood: 'Hải sản',
      vegetarian: 'Chay',
      vegan: 'Thuần chay',
      bestseller: 'Bán chạy',
      nuts: 'Các loại hạt',
      dairy: 'Sữa',
      eggs: 'Trứng',
      gluten: 'Có gluten',
      gluten_free: 'Không gluten',
    },
    negativeFilters: {
      beef: 'Không bò',
      pork: 'Không heo',
      chicken: 'Không gà',
      duck: 'Không vịt',
      poultry: 'Không gia cầm',
      fish: 'Không cá',
      shrimp: 'Không tôm',
      squid: 'Không mực',
      crab: 'Không cua',
      seafood: 'Không hải sản',
      vegetarian: 'Không chay',
      vegan: 'Không thuần chay',
      bestseller: 'Không bán chạy',
      nuts: 'Không hạt',
      dairy: 'Không sữa',
      eggs: 'Không trứng',
      gluten: 'Không gluten',
      gluten_free: 'Không món không gluten',
    },
    spiciness: {
      mild: 'Ít cay',
      medium: 'Cay vừa',
      hot: 'Cay',
    },
    ui: {
      clearFilters: 'Xóa bộ lọc',
      noItemsMatch: 'Không có món nào khớp với bộ lọc hiện tại.',
    },
  },
  ko: {
    tags: {
      beef: '소고기',
      pork: '돼지고기',
      chicken: '닭고기',
      duck: '오리고기',
      poultry: '가금류',
      fish: '생선',
      shrimp: '새우',
      squid: '오징어',
      crab: '게',
      seafood: '해산물',
      vegetarian: '채식',
      vegan: '비건',
      bestseller: '베스트셀러',
      nuts: '견과류',
      dairy: '유제품',
      eggs: '계란',
      gluten: '글루텐 함유',
      gluten_free: '글루텐 프리',
    },
    negativeFilters: {
      beef: '소고기 제외',
      pork: '돼지고기 제외',
      chicken: '닭고기 제외',
      duck: '오리고기 제외',
      poultry: '가금류 제외',
      fish: '생선 제외',
      shrimp: '새우 제외',
      squid: '오징어 제외',
      crab: '게 제외',
      seafood: '해산물 제외',
      vegetarian: '채식 제외',
      vegan: '비건 제외',
      bestseller: '베스트셀러 제외',
      nuts: '견과류 제외',
      dairy: '유제품 제외',
      eggs: '계란 제외',
      gluten: '글루텐 제외',
      gluten_free: '글루텐 프리 제외',
    },
    spiciness: {
      mild: '순한맛',
      medium: '중간 매운맛',
      hot: '매운맛',
    },
    ui: {
      clearFilters: '필터 지우기',
      noItemsMatch: '현재 필터와 일치하는 항목이 없습니다.',
    },
  },
  zh: {
    tags: {
      beef: '牛肉',
      pork: '猪肉',
      chicken: '鸡肉',
      duck: '鸭肉',
      poultry: '家禽',
      fish: '鱼',
      shrimp: '虾',
      squid: '鱿鱼',
      crab: '蟹',
      seafood: '海鲜',
      vegetarian: '素食',
      vegan: '纯素',
      bestseller: '招牌推荐',
      nuts: '坚果',
      dairy: '乳制品',
      eggs: '鸡蛋',
      gluten: '含麸质',
      gluten_free: '无麸质',
    },
    negativeFilters: {
      beef: '不含牛肉',
      pork: '不含猪肉',
      chicken: '不含鸡肉',
      duck: '不含鸭肉',
      poultry: '不含家禽',
      fish: '不含鱼',
      shrimp: '不含虾',
      squid: '不含鱿鱼',
      crab: '不含蟹',
      seafood: '不含海鲜',
      vegetarian: '非素食',
      vegan: '非纯素',
      bestseller: '非招牌推荐',
      nuts: '不含坚果',
      dairy: '不含乳制品',
      eggs: '不含鸡蛋',
      gluten: '不含麸质',
      gluten_free: '非无麸质',
    },
    spiciness: {
      mild: '微辣',
      medium: '中辣',
      hot: '辣',
    },
    ui: {
      clearFilters: '清除筛选',
      noItemsMatch: '当前筛选条件下没有匹配的项目。',
    },
  },
  'zh-TW': {
    tags: {
      beef: '牛肉',
      pork: '豬肉',
      chicken: '雞肉',
      duck: '鴨肉',
      poultry: '家禽',
      fish: '魚',
      shrimp: '蝦',
      squid: '魷魚',
      crab: '蟹',
      seafood: '海鮮',
      vegetarian: '素食',
      vegan: '純素',
      bestseller: '招牌推薦',
      nuts: '堅果',
      dairy: '乳製品',
      eggs: '雞蛋',
      gluten: '含麩質',
      gluten_free: '無麩質',
    },
    negativeFilters: {
      beef: '不含牛肉',
      pork: '不含豬肉',
      chicken: '不含雞肉',
      duck: '不含鴨肉',
      poultry: '不含家禽',
      fish: '不含魚',
      shrimp: '不含蝦',
      squid: '不含魷魚',
      crab: '不含蟹',
      seafood: '不含海鮮',
      vegetarian: '非素食',
      vegan: '非純素',
      bestseller: '非招牌推薦',
      nuts: '不含堅果',
      dairy: '不含乳製品',
      eggs: '不含雞蛋',
      gluten: '不含麩質',
      gluten_free: '非無麩質',
    },
    spiciness: {
      mild: '微辣',
      medium: '中辣',
      hot: '辣',
    },
    ui: {
      clearFilters: '清除篩選',
      noItemsMatch: '目前的篩選條件沒有符合的項目。',
    },
  },
  ru: {
    tags: {
      beef: 'Говядина',
      pork: 'Свинина',
      chicken: 'Курица',
      duck: 'Утка',
      poultry: 'Птица',
      fish: 'Рыба',
      shrimp: 'Креветки',
      squid: 'Кальмар',
      crab: 'Краб',
      seafood: 'Морепродукты',
      vegetarian: 'Вегетарианское',
      vegan: 'Веганское',
      bestseller: 'Хит продаж',
      nuts: 'Орехи',
      dairy: 'Молочные продукты',
      eggs: 'Яйца',
      gluten: 'Содержит глютен',
      gluten_free: 'Без глютена',
    },
    negativeFilters: {
      beef: 'Без говядины',
      pork: 'Без свинины',
      chicken: 'Без курицы',
      duck: 'Без утки',
      poultry: 'Без птицы',
      fish: 'Без рыбы',
      shrimp: 'Без креветок',
      squid: 'Без кальмара',
      crab: 'Без краба',
      seafood: 'Без морепродуктов',
      vegetarian: 'Не вегетарианское',
      vegan: 'Не веганское',
      bestseller: 'Не хит продаж',
      nuts: 'Без орехов',
      dairy: 'Без молочных продуктов',
      eggs: 'Без яиц',
      gluten: 'Без глютена',
      gluten_free: 'Не без глютена',
    },
    spiciness: {
      mild: 'Слабо острое',
      medium: 'Средне острое',
      hot: 'Острое',
    },
    ui: {
      clearFilters: 'Сбросить фильтры',
      noItemsMatch: 'Нет позиций, соответствующих текущим фильтрам.',
    },
  },
  fr: {
    tags: {
      beef: 'Boeuf',
      pork: 'Porc',
      chicken: 'Poulet',
      duck: 'Canard',
      poultry: 'Volaille',
      fish: 'Poisson',
      shrimp: 'Crevettes',
      squid: 'Calamar',
      crab: 'Crabe',
      seafood: 'Fruits de mer',
      vegetarian: 'Végétarien',
      vegan: 'Végan',
      bestseller: 'Best-seller',
      nuts: 'Fruits à coque',
      dairy: 'Produits laitiers',
      eggs: 'Œufs',
      gluten: 'Contient du gluten',
      gluten_free: 'Sans gluten',
    },
    negativeFilters: {
      beef: 'Sans boeuf',
      pork: 'Sans porc',
      chicken: 'Sans poulet',
      duck: 'Sans canard',
      poultry: 'Sans volaille',
      fish: 'Sans poisson',
      shrimp: 'Sans crevettes',
      squid: 'Sans calamar',
      crab: 'Sans crabe',
      seafood: 'Sans fruits de mer',
      vegetarian: 'Non végétarien',
      vegan: 'Non végan',
      bestseller: 'Pas best-seller',
      nuts: 'Sans fruits à coque',
      dairy: 'Sans produits laitiers',
      eggs: 'Sans œufs',
      gluten: 'Sans gluten',
      gluten_free: 'Pas sans gluten',
    },
    spiciness: {
      mild: 'Peu épicé',
      medium: 'Moyennement épicé',
      hot: 'Épicé',
    },
    ui: {
      clearFilters: 'Effacer les filtres',
      noItemsMatch: 'Aucun article ne correspond à vos filtres actuels.',
    },
  },
  es: {
    tags: {
      beef: 'Carne de res',
      pork: 'Cerdo',
      chicken: 'Pollo',
      duck: 'Pato',
      poultry: 'Aves',
      fish: 'Pescado',
      shrimp: 'Camarón',
      squid: 'Calamar',
      crab: 'Cangrejo',
      seafood: 'Mariscos',
      vegetarian: 'Vegetariano',
      vegan: 'Vegano',
      bestseller: 'Más vendido',
      nuts: 'Frutos secos',
      dairy: 'Lácteos',
      eggs: 'Huevos',
      gluten: 'Contiene gluten',
      gluten_free: 'Sin gluten',
    },
    negativeFilters: {
      beef: 'Sin res',
      pork: 'Sin cerdo',
      chicken: 'Sin pollo',
      duck: 'Sin pato',
      poultry: 'Sin aves',
      fish: 'Sin pescado',
      shrimp: 'Sin camarón',
      squid: 'Sin calamar',
      crab: 'Sin cangrejo',
      seafood: 'Sin mariscos',
      vegetarian: 'No vegetariano',
      vegan: 'No vegano',
      bestseller: 'No más vendido',
      nuts: 'Sin frutos secos',
      dairy: 'Sin lácteos',
      eggs: 'Sin huevos',
      gluten: 'Sin gluten',
      gluten_free: 'No sin gluten',
    },
    spiciness: {
      mild: 'Poco picante',
      medium: 'Picante medio',
      hot: 'Picante',
    },
    ui: {
      clearFilters: 'Borrar filtros',
      noItemsMatch: 'Ningún artículo coincide con los filtros actuales.',
    },
  },
  de: {
    tags: {
      beef: 'Rindfleisch',
      pork: 'Schweinefleisch',
      chicken: 'Hähnchen',
      duck: 'Ente',
      poultry: 'Geflügel',
      fish: 'Fisch',
      shrimp: 'Garnelen',
      squid: 'Tintenfisch',
      crab: 'Krabbe',
      seafood: 'Meeresfrüchte',
      vegetarian: 'Vegetarisch',
      vegan: 'Vegan',
      bestseller: 'Bestseller',
      nuts: 'Nüsse',
      dairy: 'Milchprodukte',
      eggs: 'Eier',
      gluten: 'Enthält Gluten',
      gluten_free: 'Glutenfrei',
    },
    negativeFilters: {
      beef: 'Ohne Rindfleisch',
      pork: 'Ohne Schweinefleisch',
      chicken: 'Ohne Hähnchen',
      duck: 'Ohne Ente',
      poultry: 'Ohne Geflügel',
      fish: 'Ohne Fisch',
      shrimp: 'Ohne Garnelen',
      squid: 'Ohne Tintenfisch',
      crab: 'Ohne Krabbe',
      seafood: 'Ohne Meeresfrüchte',
      vegetarian: 'Nicht vegetarisch',
      vegan: 'Nicht vegan',
      bestseller: 'Kein Bestseller',
      nuts: 'Ohne Nüsse',
      dairy: 'Ohne Milchprodukte',
      eggs: 'Ohne Eier',
      gluten: 'Ohne Gluten',
      gluten_free: 'Nicht glutenfrei',
    },
    spiciness: {
      mild: 'Mild',
      medium: 'Mittelscharf',
      hot: 'Scharf',
    },
    ui: {
      clearFilters: 'Filter löschen',
      noItemsMatch: 'Keine Artikel entsprechen Ihren aktuellen Filtern.',
    },
  },
  hi: {
    tags: {
      beef: 'बीफ़',
      pork: 'पोर्क',
      chicken: 'चिकन',
      duck: 'बत्तख',
      poultry: 'पोल्ट्री',
      fish: 'मछली',
      shrimp: 'झींगा',
      squid: 'स्क्विड',
      crab: 'केकड़ा',
      seafood: 'समुद्री भोजन',
      vegetarian: 'शाकाहारी',
      vegan: 'वीगन',
      bestseller: 'सबसे लोकप्रिय',
      nuts: 'मेवे',
      dairy: 'डेयरी',
      eggs: 'अंडे',
      gluten: 'ग्लूटेन युक्त',
      gluten_free: 'ग्लूटेन-फ्री',
    },
    negativeFilters: {
      beef: 'बीफ़ नहीं',
      pork: 'पोर्क नहीं',
      chicken: 'चिकन नहीं',
      duck: 'बत्तख नहीं',
      poultry: 'पोल्ट्री नहीं',
      fish: 'मछली नहीं',
      shrimp: 'झींगा नहीं',
      squid: 'स्क्विड नहीं',
      crab: 'केकड़ा नहीं',
      seafood: 'समुद्री भोजन नहीं',
      vegetarian: 'शाकाहारी नहीं',
      vegan: 'वीगन नहीं',
      bestseller: 'सबसे लोकप्रिय नहीं',
      nuts: 'मेवे नहीं',
      dairy: 'डेयरी नहीं',
      eggs: 'अंडे नहीं',
      gluten: 'ग्लूटेन नहीं',
      gluten_free: 'ग्लूटेन-फ्री नहीं',
    },
    spiciness: {
      mild: 'हल्का मसालेदार',
      medium: 'मध्यम मसालेदार',
      hot: 'तेज़ मसालेदार',
    },
    ui: {
      clearFilters: 'फ़िल्टर साफ़ करें',
      noItemsMatch: 'आपके मौजूदा फ़िल्टर से कोई आइटम मेल नहीं खाता।',
    },
  },
  id: {
    tags: {
      beef: 'Sapi',
      pork: 'Babi',
      chicken: 'Ayam',
      duck: 'Bebek',
      poultry: 'Unggas',
      fish: 'Ikan',
      shrimp: 'Udang',
      squid: 'Cumi-cumi',
      crab: 'Kepiting',
      seafood: 'Makanan laut',
      vegetarian: 'Vegetarian',
      vegan: 'Vegan',
      bestseller: 'Terlaris',
      nuts: 'Kacang',
      dairy: 'Produk susu',
      eggs: 'Telur',
      gluten: 'Mengandung gluten',
      gluten_free: 'Bebas gluten',
    },
    negativeFilters: {
      beef: 'Tanpa sapi',
      pork: 'Tanpa babi',
      chicken: 'Tanpa ayam',
      duck: 'Tanpa bebek',
      poultry: 'Tanpa unggas',
      fish: 'Tanpa ikan',
      shrimp: 'Tanpa udang',
      squid: 'Tanpa cumi-cumi',
      crab: 'Tanpa kepiting',
      seafood: 'Tanpa makanan laut',
      vegetarian: 'Bukan vegetarian',
      vegan: 'Bukan vegan',
      bestseller: 'Bukan terlaris',
      nuts: 'Tanpa kacang',
      dairy: 'Tanpa produk susu',
      eggs: 'Tanpa telur',
      gluten: 'Tanpa gluten',
      gluten_free: 'Bukan bebas gluten',
    },
    spiciness: {
      mild: 'Sedikit pedas',
      medium: 'Pedas sedang',
      hot: 'Pedas',
    },
    ui: {
      clearFilters: 'Hapus filter',
      noItemsMatch: 'Tidak ada item yang cocok dengan filter Anda saat ini.',
    },
  },
  ja: {
    tags: {
      beef: '牛肉',
      pork: '豚肉',
      chicken: '鶏肉',
      duck: '鴨肉',
      poultry: '家禽',
      fish: '魚',
      shrimp: 'エビ',
      squid: 'イカ',
      crab: 'カニ',
      seafood: 'シーフード',
      vegetarian: 'ベジタリアン',
      vegan: 'ヴィーガン',
      bestseller: '人気メニュー',
      nuts: 'ナッツ',
      dairy: '乳製品',
      eggs: '卵',
      gluten: 'グルテン入り',
      gluten_free: 'グルテンフリー',
    },
    negativeFilters: {
      beef: '牛肉なし',
      pork: '豚肉なし',
      chicken: '鶏肉なし',
      duck: '鴨肉なし',
      poultry: '家禽なし',
      fish: '魚なし',
      shrimp: 'エビなし',
      squid: 'イカなし',
      crab: 'カニなし',
      seafood: 'シーフードなし',
      vegetarian: 'ベジタリアン以外',
      vegan: 'ヴィーガン以外',
      bestseller: '人気メニュー以外',
      nuts: 'ナッツなし',
      dairy: '乳製品なし',
      eggs: '卵なし',
      gluten: 'グルテンなし',
      gluten_free: 'グルテンフリー以外',
    },
    spiciness: {
      mild: '辛さひかえめ',
      medium: '中辛',
      hot: '辛口',
    },
    ui: {
      clearFilters: 'フィルターをクリア',
      noItemsMatch: '現在のフィルターに一致する項目はありません。',
    },
  },
  ms: {
    tags: {
      beef: 'Daging lembu',
      pork: 'Daging babi',
      chicken: 'Ayam',
      duck: 'Itik',
      poultry: 'Unggas',
      fish: 'Ikan',
      shrimp: 'Udang',
      squid: 'Sotong',
      crab: 'Ketam',
      seafood: 'Makanan laut',
      vegetarian: 'Vegetarian',
      vegan: 'Vegan',
      bestseller: 'Paling laris',
      nuts: 'Kekacang',
      dairy: 'Produk tenusu',
      eggs: 'Telur',
      gluten: 'Mengandungi gluten',
      gluten_free: 'Bebas gluten',
    },
    negativeFilters: {
      beef: 'Tiada daging lembu',
      pork: 'Tiada daging babi',
      chicken: 'Tiada ayam',
      duck: 'Tiada itik',
      poultry: 'Tiada unggas',
      fish: 'Tiada ikan',
      shrimp: 'Tiada udang',
      squid: 'Tiada sotong',
      crab: 'Tiada ketam',
      seafood: 'Tiada makanan laut',
      vegetarian: 'Bukan vegetarian',
      vegan: 'Bukan vegan',
      bestseller: 'Bukan paling laris',
      nuts: 'Tiada kekacang',
      dairy: 'Tiada produk tenusu',
      eggs: 'Tiada telur',
      gluten: 'Tiada gluten',
      gluten_free: 'Bukan bebas gluten',
    },
    spiciness: {
      mild: 'Kurang pedas',
      medium: 'Pedas sederhana',
      hot: 'Pedas',
    },
    ui: {
      clearFilters: 'Kosongkan penapis',
      noItemsMatch: 'Tiada item yang sepadan dengan penapis semasa anda.',
    },
  },
  th: {
    tags: {
      beef: 'เนื้อวัว',
      pork: 'หมู',
      chicken: 'ไก่',
      duck: 'เป็ด',
      poultry: 'สัตว์ปีก',
      fish: 'ปลา',
      shrimp: 'กุ้ง',
      squid: 'ปลาหมึก',
      crab: 'ปู',
      seafood: 'อาหารทะเล',
      vegetarian: 'มังสวิรัติ',
      vegan: 'วีแกน',
      bestseller: 'เมนูขายดี',
      nuts: 'ถั่ว',
      dairy: 'ผลิตภัณฑ์นม',
      eggs: 'ไข่',
      gluten: 'มีกลูเตน',
      gluten_free: 'ปราศจากกลูเตน',
    },
    negativeFilters: {
      beef: 'ไม่มีเนื้อวัว',
      pork: 'ไม่มีหมู',
      chicken: 'ไม่มีไก่',
      duck: 'ไม่มีเป็ด',
      poultry: 'ไม่มีสัตว์ปีก',
      fish: 'ไม่มีปลา',
      shrimp: 'ไม่มีกุ้ง',
      squid: 'ไม่มีปลาหมึก',
      crab: 'ไม่มีปู',
      seafood: 'ไม่มีอาหารทะเล',
      vegetarian: 'ไม่ใช่มังสวิรัติ',
      vegan: 'ไม่ใช่วีแกน',
      bestseller: 'ไม่ใช่เมนูขายดี',
      nuts: 'ไม่มีถั่ว',
      dairy: 'ไม่มีผลิตภัณฑ์นม',
      eggs: 'ไม่มีไข่',
      gluten: 'ไม่มีกลูเตน',
      gluten_free: 'ไม่ปราศจากกลูเตน',
    },
    spiciness: {
      mild: 'เผ็ดน้อย',
      medium: 'เผ็ดปานกลาง',
      hot: 'เผ็ด',
    },
    ui: {
      clearFilters: 'ล้างตัวกรอง',
      noItemsMatch: 'ไม่มีรายการที่ตรงกับตัวกรองปัจจุบัน',
    },
  },
});

function normalizeMenuTagLanguageCode(value = '') {
  return String(value || '').trim();
}

export function getMenuTagI18nPack(languageCode = 'en') {
  const normalized = normalizeMenuTagLanguageCode(languageCode);
  const languageBase = normalized.split('-')[0] || normalized;
  const translated =
    MENU_TAG_I18N_BY_LANGUAGE[normalized]
    || MENU_TAG_I18N_BY_LANGUAGE[languageBase]
    || MENU_TAG_I18N_BY_LANGUAGE.en
    || DEFAULT_MENU_TAG_I18N;

  return {
    tags: {
      ...DEFAULT_MENU_TAG_I18N.tags,
      ...(translated.tags || {}),
    },
    negativeFilters: {
      ...DEFAULT_MENU_TAG_I18N.negativeFilters,
      ...(translated.negativeFilters || {}),
    },
    spiciness: {
      ...DEFAULT_MENU_TAG_I18N.spiciness,
      ...(translated.spiciness || {}),
    },
    ui: {
      ...DEFAULT_MENU_TAG_I18N.ui,
      ...(translated.ui || {}),
    },
  };
}
